
// The intent: display currency as expected, above 1 million begin ignoring less significant digits
export default (value, showFull = false, spellOut = true) => {
  let parsed = Number((value + '').replace(/[^0-9.]/g, ''))
  if (isNaN(parsed)) return value

  const isMil = value >= 1000000 && value < 1000000000
  const isBil = value >= 1000000000

  const denominator = isMil ? 1000000 : isBil ? 1000000000 : 0;

  // if the ending digit is a zero, don't show it
  const digitCount = (parsed / denominator).toFixed(2).toString().split('').pop() == 0 ? 1 : 2

  parsed = (isMil || isBil) && !showFull ? (parsed / denominator).toFixed( digitCount ) : parsed.toFixed(2)
  
  const indexDecimal = parsed.indexOf('.')
  const valDecimal = indexDecimal !== -1 ? Number(parsed.slice(indexDecimal + 1)) : ''
  if (indexDecimal !== -1 && valDecimal == 0) parsed = parsed.slice(0, indexDecimal)

  if ( indexDecimal !== -1 && valDecimal != 0 ) {
    return `$${parsed}${isMil && !showFull ? spellOut ? ' Million' : 'M' : isBil && !showFull ? spellOut ? ' Billion' : ' B' : ''}`
  
  } else {
    // if (indexDecimal !== -1 && valDecimal == 0) parsed = parsed.slice(0, indexDecimal)

    const chunks = Math.floor(parsed.length / 3)
    const firstChunk = parsed.length % 3

    const main = []
    if (firstChunk) main.push(parsed.slice(0, firstChunk))

    for (let i = 0; i < chunks; i++) {
      main.push(parsed.slice(firstChunk + (i * 3), firstChunk + (i * 3) + 3))
    }

    return `$${main.join(',')}${valDecimal ? '.' + valDecimal : ''}${isMil && !showFull ? spellOut ? ' Million' : 'M' : isBil && !showFull ? spellOut ? ' Billion' : ' B' : ''}`
  }
  // let val_text = '$'+parsed.replace(/\.?0*$/,'')
  // let suffix_text = isMil && !showFull ? spellOut ? ' Million' : 'M' : isBil && !showFull ? spellOut ? ' Billion' : 'B' : ''

  // return val_text+''+suffix_text
}


// WEBPACK FOOTER //
// ./src/filters/currency.js